<template>
	<section class="pb-32 text-white container mx-auto w-11/12">
		<h4 class="relative font-bold uppercase text-black text-3xl">{{ $t("get-in-touch.title") }}</h4>

		<div class="grid grid-flow-col grid-cols-1 md:grid-cols-2 gap-10">
			<form class="relative mt-10 w-full">
				<p class="text-red text-sm pt-0 -mt-10 pb-5"
					v-if="error != ''">
					{{ error }}
				</p>

				<Spinner class="absolute w-full h-full flex items-center pb-32"
					v-if="status === 1" />

				<div class="absolute z-10 w-full h-full flex flex-col items-center pb-32 justify-center text-black"
					v-else-if="status === 2">
					<h5 class="text-green">{{ $t('get-in-touch.messages.success.title') }}</h5>
					<p class="text-sm font-light max-w-sm text-center mt-2">
						{{ $t('get-in-touch.messages.success.description') }}
					</p>
				</div>

				<div :class="status === 2 ? 'opacity-40' : ''">
					<input type="text"
						:placeholder="$t('get-in-touch.form.name')"
						class="text-black border rounded-full shadow-lg pt-5 pb-4 px-5 text-sm w-full mb-2 focus:outline-none"
						:class="formData.name === '' && error ? 'border-red-lightest' : 'border-black-lightest'"
						v-model="formData.name"
						:disabled="status > 0 ? 'disabled' : undefined" />

					<input type="email"
						:placeholder="$t('get-in-touch.form.email')"
						class="text-black border rounded-full shadow-lg pt-5 pb-4 px-5 text-sm w-full mb-2 focus:outline-none"
						:class="formData.emailAddress === '' && error ? 'border-red-lightest' : 'border-black-lightest'"
						v-model="formData.emailAddress"
						:disabled="status > 0 ? 'disabled' : undefined" />

					<textarea :placeholder="$t('get-in-touch.form.message')"
						class="text-black border rounded-3xl shadow-lg pt-5 pb-4 px-5 text-sm w-full mb-2 resize-none focus:outline-none"
						:class="formData.message === '' && error ? 'border-red-lightest' : 'border-black-lightest'"
						maxlength="1000"
						rows="10"
						v-model="formData.message"
						:disabled="status > 0 ? 'disabled' : undefined"></textarea>

					<div class="grid grid-flow-col w-max ml-auto mr-0 gap-2">
						<button type="reset"
							:disabled="status > 0 ? 'disabled' : undefined"
							class="bg-black-darkest rounded-full hover:shadow-md text-white no-underline py-3 px-7 uppercase font-bold text-xs mt-2 float-left focus:outline-none"
							@click="resetValues">
							{{ $t('get-in-touch.form.clear-button') }}
						</button>

						<button type="button"
							class="bg-gold text-white rounded-full hover:shadow-md no-underline py-3 px-7 uppercase font-bold text-xs mt-2 float-left focus:outline-none"
							:disabled="status > 0 ? 'disabled' : undefined"
							@click="sendEmail">
							{{ $t('get-in-touch.form.submit-button') }}
						</button>
					</div>
				</div>

			</form>

			<!-- CHANGE IMAGE COLOR TO BLACK INSTEAD OF BLUE -->
			<img src="/img/contacts.webp"
				loading="lazy"
				alt=""
				class="hidden md:block md:w-full lg:w-10/12 xl:w-9/12 w-9/12 mx-auto w-9/12 mx-auto self-end" />
		</div>
	</section>
</template>

<script>
import Spinner from '@/components/Spinner'

export default {
	components: { Spinner },

	data() {
		return {
			formData: {
				name: '',
				emailAddress: '',
				message: '',
			},

			status: 0,
			error: '',
		}
	},

	methods: {
		resetValues() {
			this.formData.name = ''
			this.formData.emailAddress = ''
			this.formData.message = ''
			this.error = ''
		},

		sendEmail() {
			if (
				this.formData.name === '' ||
				this.formData.emailAddress === '' ||
				this.formData.message === ''
			) {
				this.error = this.$t(
					'get-in-touch.messages.all-fields-are-required',
				)
				return
			}

			this.error = ''
			this.status = 1
			this.$store
				.dispatch('sendEmail', this.formData)
				.then(() => {
					this.status = 2
				})
				.catch(() => {
					this.status = 0
					this.error = this.$t(
						'get-in-touch.messages.unexpected-error',
					)
				})
		},
	},
}
</script>